import "./style.scss";
import { useTranslation } from "react-i18next";

const Toggle = () => {
    const { t } = useTranslation();
    let path = window.location.pathname

    return (
        <ul className="toggle-login-register">
            <li className={path == `/login` && 'active'}>
                <a href={`/login`}>{t("nav_log_in")}</a>
            </li>
            <li className={path !== `/login` && 'active'}>
                <a href={`/registration`}>{t("register")}</a>
            </li>
        </ul>
    );
};

export default Toggle;
